import { render, staticRenderFns } from "./RouterTabs.vue?vue&type=template&id=27d4a3e7&scoped=true&"
import script from "./RouterTabs.vue?vue&type=script&lang=js&"
export * from "./RouterTabs.vue?vue&type=script&lang=js&"
import style0 from "./RouterTabs.vue?vue&type=style&index=0&id=27d4a3e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d4a3e7",
  null
  
)

export default component.exports